export const BACKEND_PATH = '/api';

export const endpoints = {
  tweeters: `${BACKEND_PATH}/tweeter/`,
  virality: `${BACKEND_PATH}/virality/`,
  mnistPredict: `${BACKEND_PATH}/mnist/predict/`,
  mnistExplain: `${BACKEND_PATH}/mnist/explain/`,
  songGenerate: `${BACKEND_PATH}/songWriter/generate/`,
  styleTransfer: `${BACKEND_PATH}/styleTrans/transform/`,
  makeMove: `${BACKEND_PATH}/boardGamer/make_move/`,
  diet: `${BACKEND_PATH}/babyfood/diet/`,
};
